import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export const TurnKeyProjects: React.FC = () => {
  const { t } = useTranslation();
  const [words, setWords] = useState<string[]>([]);

  useEffect(() => {
    const heading = t("turnkey_heading");
    setWords(heading.split(" "));
  }, [t]);

  const sections = [
    {
      img: "/sustain1.webp",
      alt: t("turnkey_section_1_alt"),
      num: "01",
      title: t("turnkey_section_1_title"),
      text: t("turnkey_section_1_text"),
    },
    {
      img: "/auto.webp",
      alt: t("turnkey_section_2_alt"),
      num: "02",
      title: t("turnkey_section_2_title"),
      text: t("turnkey_section_2_text"),
    },
    {
      img: "/sustain4.webp",
      alt: t("turnkey_section_3_alt"),
      num: "03",
      title: t("turnkey_section_3_title"),
      text: t("turnkey_section_3_text"),
    },
  ];

  return (
    <div className="w-full">

      {/* HERO */}
      <div className="relative h-screen flex items-end justify-start px-[5%] pb-16 overflow-hidden bg-[#0a2318]">

        <img
          src="/automation-hero.jpg"
          alt="Greenhouse"
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover opacity-60"
        />

       


        {/* Content */}
        <div className="relative z-10 max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="inline-block text-[11px] tracking-[3px] uppercase text-[#7EDE56] border border-[#7EDE56]/30 px-4 py-1.5 rounded-full mb-8"
          >
            {t("turnkey_label")}
          </motion.div>

          <div className="flex flex-wrap gap-3 mb-8">
            {words.map((word, i) => (
              <motion.span
                key={i}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.12 }}
                className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-[#ffffff] leading-tighter"
              >
                {word}
              </motion.span>
            ))}
          </div>


        </div>

       
      </div>

      {sections.map((section, index) => (
        <React.Fragment key={index}>
          <div className="grid grid-cols-1 md:grid-cols-2 min-h-[70vh]">

            {/* Image */}
            <div className={`relative overflow-hidden bg-[#1C4734] h-[350px] md:h-[500px] ${index % 2 !== 0 ? "md:order-2" : ""}`}>
              <img
                src={section.img}
                alt={section.alt}
                loading="lazy"
                className="w-full h-full object-fit transition-transform duration-700 hover:scale-105"
              />
            </div>

            <div className={`flex flex-col justify-center px-[6%] py-16 bg-[#ffffff] ${index % 2 !== 0 ? "md:order-1" : ""}`}>
              <div className="text-[6rem] font-black text-[#1C4734]/10 leading-none -mb-2 select-none">
                {section.num}
              </div>
              <h3 className="text-[#002F3F] text-2xl md:text-4xl font-bold mb-5 leading-tight">
                {section.title}
              </h3>
              <p className="text-[#002F3F] text-base md:text-lg leading-relaxed mb-8 max-w-md">
                {section.text}
              </p>

            </div>

          </div>

          {/* Divider */}
          {index < sections.length - 1 && (
            <div className="mx-[5%] h-px bg-gradient-to-r from-transparent via-[#1C4734]/20 to-transparent" />
          )}
        </React.Fragment>
      ))}

    </div>
  );
};